<template>
  <SrpModal :isVisible="props.isVisible" @update:isVisible="isVisible => emit('update:isVisible', isVisible)">
    <template #content>
      <ChooseCreatorDateForm class="choose-creator-date-form" v-model:chooseCreatorEstimatedDate="_chooseCreatorEstimatedDate" v-model:chooseCreatorEstimatedNotes="_chooseCreatorEstimatedNotes" />
    </template>

    <template #footer="{ closeModal }">
      <SrpButton fill="outlined" color="gray" @click="closeModal" :isDisabled="isSaving">Cancel</SrpButton>

      <SrpButton @click="save(closeModal)" :isDisabled="isSaving">
        <template #icon>
          <LoadingIcon v-if="isSaving" :size="18" />
          <IconEmbedded v-else name="save_2" :size="22" color="rgba(255, 255, 255, 0.4)" />
        </template>
        Save
      </SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import ChooseCreatorDateForm from "./ChooseCreatorDateForm.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

const props = withDefaults(
  defineProps<{
    isVisible: boolean;
    chooseCreatorEstimatedDate: string | null;
    chooseCreatorEstimatedNotes: string | null;
    saveCallback: () => Promise<void>;
  }>(),
  {
    isVisible: false,
    chooseCreatorEstimatedDate: null,
    chooseCreatorEstimatedNotes: null,
    saveCallback: async () => {},
  }
);

const emit = defineEmits<{
  (e: "update:isVisible", isVisible: boolean): void;
  (e: "save", newDate: string, newNote: string | null): void;
  (e: "update:chooseCreatorEstimatedDate", value: string): void;
  (e: "update:chooseCreatorEstimatedNotes", value: string | null): void;
}>();

// isSaving flag ==============================================================
const isSaving = ref<boolean>(false);

async function save(closeModalCallback: () => void) {
  emit("update:chooseCreatorEstimatedDate", _chooseCreatorEstimatedDate.value);
  emit("update:chooseCreatorEstimatedNotes", _chooseCreatorEstimatedNotes.value);

  isSaving.value = true;

  await props.saveCallback();

  isSaving.value = false;

  closeModalCallback();
}

// Local values ===============================================================
const _chooseCreatorEstimatedDate = ref<string>("");
const _chooseCreatorEstimatedNotes = ref<string>("");

onMounted(() => {
  _chooseCreatorEstimatedDate.value = props.chooseCreatorEstimatedDate;
  _chooseCreatorEstimatedNotes.value = props.chooseCreatorEstimatedNotes;
});
</script>

<style scoped lang="scss">
.choose-creator-date-form {
  :deep(.when-can-you-choose-form__title) {
    font-size: 35px;
    line-height: 38px;
  }
}
</style>
